import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SidebarActiveLinkService {
  private activeLinkSubject = new BehaviorSubject<string>(
    sessionStorage.getItem('activeLink') || 'documenti'
  );

  activeLink$ = this.activeLinkSubject.asObservable();

  setActiveLink(link: string): void {
    sessionStorage.setItem('activeLink', link);
    this.activeLinkSubject.next(link);
  }

  getActiveLink(): string {
    return sessionStorage.getItem('activeLink') || 'documenti';
  }
}

